import { array, date, number, object, SchemaOf, string } from "yup";
import { toast } from "react-toastify";
import { requiredFieldValidationMessage } from "../../../Forms/ValidationMessages";
import { BidPack } from "../BidPack";
import { BidPackDestination } from "../BidPackDestination";

export const bidPackSchema: SchemaOf<BidPack> = object()
  .shape({
    Name: string().required(requiredFieldValidationMessage("Name")),
    TransportType: number(),
    StartDate: date()
      .typeError("Invalid start date")
      .required(requiredFieldValidationMessage("Start Date")),
    OriginRegions: array().of(
      object().shape({
        CountryId: number().notOneOf([null, 0], "Please choose a country"),
      })
    ),
    // when Transport Type is LTL, only one ODC can be added to destinations
    Destinations: array()
      .ensure()
      .when("TransportType", {
        is: 1,
        then: array().test({
          test: (values) => notMoreThanOneOdcInDestinationsCheck(values),
        }),
      }),
  })
  .required();

const notMoreThanOneOdcInDestinationsCheck = (values: any): boolean => {
  const destinations = values as Array<BidPackDestination>;
  const odcsInDestinations = destinations.filter(
    (destination) => destination.DestinationTypeId === 3
  );
  const check = odcsInDestinations.length < 2;
  if (check) return check;
  throw toast.error("Not more than one ODC allowed");
};
